import { TweenMax, TimelineMax, Power2 } from 'gsap'
import bus from './bus'
import UI from './utils/UI'

UI({
  component: '.js-drawer',
  circle: '.js-drawer-circle',
  scroller: '.js-drawer-scroller'
}, ({ component, circle, scroller }) => {
  const state = {
    scrollTop: 0,
    currentTween: null
  }

  setCircleSize()
  bus.on('is-drawer-open', toggleDrawer)
  bus.on('window-resize', setCircleSize)

  function toggleDrawer(newState) {
    state.currentTween && state.currentTween.kill()
    state.currentTween = newState ? getDrawerOpenTimeline() : getDrawerCloseTimeline()
    state.currentTween.paused(false)
  }

  function beforeOpen() {
    bus.emit('drawer-open-start')
    TweenMax.set(component, { display: 'block' })
    const htmlScrollTop = document.querySelector('html').scrollTop
    const bodyScrollTop = document.body.scrollTop
    setDrawerTabindex(0)
    state.scrollTop = htmlScrollTop > bodyScrollTop ? htmlScrollTop : bodyScrollTop
  }

  function afterOpen() {
    document.body.style.top = -state.scrollTop
    document.body.classList.add('is-drawer-open')
    bus.emit('drawer-open-ready')
  }

  function beforeClose() {
    setDrawerTabindex(-1)
    document.body.classList.remove('is-drawer-open')
    document.body.style.top = ''
    window.scrollTo(0, state.scrollTop)
  }

  function afterClose() {
    TweenMax.set(component, { display: 'none' })
    component.classList.remove('is-open')
    document.body.classList.remove('is-drawer-open')
  }

  function getDrawerOpenTimeline() {
    const tl = new TimelineMax({ paused: true, onStart: beforeOpen, onComplete: afterOpen })
    tl.fromTo(circle, 0.5, { scale: 0, x: '50%', y: '-50%' }, { scale: 1, x: '50%', y: '-50%', ease: Power2.easeInOut })
    tl.fromTo(scroller, 0.2, { opacity: 0 }, { opacity: 1, ease: Power2.easeInOut }, '-=0.2')
    return tl
  }

  function getDrawerCloseTimeline() {
    const tl = new TimelineMax({ paused: true, onStart: beforeClose, onComplete: afterClose })
    tl.to(scroller, 0.1, { opacity: 0 })
    tl.to(circle, 0.3, { scale: 0, x: '50%', y: '-50%', ease: Power2.easeInOut }, 0)
    return tl
  }

  function setDrawerTabindex(val) {
    [...component.querySelectorAll('a')].forEach(el => el.setAttribute('tabindex', val))
  }

  function determineCircleSize () {
    const adjacent = Math.max(window.innerWidth, window.innerHeight) * 2
    return Math.sqrt(adjacent * adjacent + adjacent * adjacent)
  }

  function setCircleSize () {
    const size = determineCircleSize()
    circle.style.width = size + 'px'
    circle.style.height = size + 'px'
  }
})
